import { EventContentArg } from "@fullcalendar/core";
import {
  combineDateAndTime,
  Day,
  getFirstItem,
  UsersPermissionsUser,
  workedHours
} from "@mc-intranet/shared";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BugReportIcon from "@mui/icons-material/BugReport";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import HomeIcon from "@mui/icons-material/Home";
import ImageIcon from "@mui/icons-material/Image";
import { Box } from "@mui/material";
import React from "react";

import {
  correctPuncesColor,
  hoursOffColor,
  isSickColor,
  missingPuncesColor,
  vacationColor
} from "../../../theme";
interface Props {
  user?: Partial<UsersPermissionsUser>;
  eventContent: EventContentArg;
}

const PresenceCell: React.FC<Props> = (props) => {
  const { user, eventContent } = props;
  const { event } = eventContent;
  const { display, extendedProps } = event;
  const item = extendedProps as Day;

  if (!item?.documentId) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { date, hoursOff, isSick, punches, vacation } = item;
  const isEmpty =
    getFirstItem(hoursOff) === undefined &&
    !isSick &&
    getFirstItem(punches) === undefined &&
    !vacation;

  if (display === "background" && isEmpty) return null;

  const { ore, minuti, totale } = workedHours(item);

  const missingPunces = user?.isPartTime ? false : totale < 7.9;

  const renderIcon = (location: string) => {
    switch (location) {
      case "ufficio":
        return (
          <AccountBalanceIcon
            className="location-icons"
            sx={{ fontSize: 18 }}
          />
        );
      case "casa":
        return <HomeIcon className="location-icons" sx={{ fontSize: 18 }} />;

      default:
        return (
          <DirectionsCarIcon className="location-icons" sx={{ fontSize: 18 }} />
        );
    }
  };
  // console.log("missingPunces", missingPunces);

  return (
    <>
      {!vacation && !isSick && punches && (
        <>
          <Box
            className="days-wrapper"
            display={{ xs: "none", md: "flex" }}
            flexDirection="column"
            alignItems="center"
            px={1}
            overflow="auto"
          >
            {punches.length > 0 && (
              <Box
                className="total-of-the-day"
                paddingBottom="3px"
                color={missingPunces ? missingPuncesColor : correctPuncesColor}
                fontWeight="bold"
              >
                {`${ore} ore${minuti === 0 ? "" : " " + minuti + " min"}`}
              </Box>
            )}
            <Box className="hours" flex={1}>
              {punches.map((punch) => {
                return (
                  <Box
                    key={punch?.documentId}
                    className="row"
                    color="text.primary"
                    display={"flex"}
                    alignItems="center"
                  >
                    {renderIcon(punch?.location as string)}
                    <Box component="span" className="time" marginLeft={1}>
                      <>
                        {combineDateAndTime(
                          date,
                          punch?.in,
                          "HH:mm"
                        )}
                      </>
                    </Box>
                    {(
                      <>
                        {combineDateAndTime(
                          date,
                          punch?.out,
                          "HH:mm"
                        )}
                      </>
                    ) && (
                      <>
                        <Box component="span"> - </Box>
                        <Box component="span" className="time">
                          <>
                            {combineDateAndTime(
                              date,
                              punch?.out,
                              "HH:mm"
                            )}
                          </>
                        </Box>
                      </>
                    )}
                  </Box>
                );
              })}
              {hoursOff &&
                hoursOff.map((hours) => {
                  return (
                    <Box
                      key={hours?.documentId}
                      className="row"
                      color={hoursOffColor}
                      title="Permessi"
                      display={"flex"}
                      alignItems="center"
                    >
                      <ImageIcon
                        className="location-icons hoursOfff"
                        sx={{ fontSize: 18 }}
                      />
                      <Box component="span" className="time-off" marginLeft={1}>
                        <>
                          {combineDateAndTime(
                            date,
                            hours?.from,
                            "HH:mm"
                          )}
                        </>
                      </Box>
                      {combineDateAndTime(
                        date,
                        hours?.to,
                        "HH:mm"
                      ) && (
                        <>
                          <Box component="span"> - </Box>
                          <Box component="span" className="time-off">
                            <>
                              {combineDateAndTime(
                                date,
                                hours?.to,
                                "HH:mm"
                              )}
                            </>
                          </Box>
                        </>
                      )}
                    </Box>
                  );
                })}
            </Box>
          </Box>
          {/* mobile */}
          <Box
            className="days-wrapper"
            display={{ xs: "flex", md: "none" }}
            flexDirection="column"
            alignItems="center"
            px={1}
            overflow="auto"
            color={
              hoursOff && hoursOff?.length > 0
                ? hoursOffColor
                : "transparent"
            }
          >
            <Box
              bgcolor={
                punches?.length > 0
                  ? missingPunces
                    ? missingPuncesColor
                    : correctPuncesColor
                  : "transparent"
              }
              borderRadius="50%"
              mb="3px"
              height="10px"
              width="10px"
            ></Box>
            {hoursOff && hoursOff?.length > 0 && (
              <ImageIcon
                className="location-icons vacation"
                sx={{ fontSize: 18 }}
              />
            )}
          </Box>
        </>
      )}
      {item && vacation && (
        <Box
          className="vacation"
          display="flex"
          alignItems="center"
          justifyContent="center"
          px={1}
          color={vacationColor}
        >
          <ImageIcon
            className="location-icons vacation"
            sx={{ fontSize: 18 }}
          />
          <Box
            component="span"
            marginLeft={1}
            display={{ xs: "none", md: "inline-block" }}
            color="text.primary"
          >
            Ferie
          </Box>
        </Box>
      )}
      {item && isSick && (
        <Box
          className="is-sick"
          display="flex"
          alignItems="center"
          justifyContent="center"
          px={1}
          color={isSickColor}
        >
          <BugReportIcon
            className="location-icons is-sick"
            sx={{ fontSize: 18 }}
          />
          <Box
            component="span"
            marginLeft={1}
            display={{ xs: "none", md: "inline-block" }}
            color="text.primary"
          >
            In Malattia
          </Box>
        </Box>
      )}
    </>
  );
};

export default PresenceCell;
